import axios from "axios";
import { apiPost } from "api/callApi";
import { MAX_FILE_SIZE } from "utils/config";

export const MAX_JOURNAL_ATTACHMENT_SIZE = MAX_FILE_SIZE; //bytes

export const formatAttachmentSize = (sizeInBytes = 0) => {
  if (sizeInBytes > 1048576) {
    return `${(sizeInBytes / 1048576).toFixed(2)} MB`;
  }
  return `${(sizeInBytes / 1024).toFixed(2)} KB`;
};

export const getAttachmentName = (attachment = {}) =>
  attachment.fileName || attachment.name || "Attachment";

export const getAttachmentSizeBytes = (attachment = {}) => {
  if (attachment.size) return Number(attachment.size);
  if (attachment.fileSize) return Number(attachment.fileSize) * 1024;
  return 0;
};

export const getAttachmentPreview = (attachment = {}) =>
  attachment.previewUrl || attachment.fileUrl || "";

export const uploadJournalAttachment = async (file) => {
  const fileType = file.type || "application/octet-stream";
  const presignedRes = await apiPost("/v1/file/fileuploadurl", {
    fileName: file.name,
    fileType,
  });

  await axios.put(presignedRes.uploadUrl, file, {
    headers: {
      "Content-Type": fileType,
    },
  });

  return {
    fileName: file.name,
    fileType,
    fileSize: (file.size / 1024).toFixed(2),
    fileUrl: presignedRes.filekey,
    name: file.name,
    size: file.size,
    type: fileType,
    previewUrl: URL.createObjectURL(file),
    isUploadedAttachment: true,
  };
};

export const uploadJournalAttachments = async (files) => {
  const uploaded = [];
  for (const file of files) {
    uploaded.push(await uploadJournalAttachment(file));
  }
  return uploaded;
};

export const toJournalAttachmentPayload = (attachments = []) =>
  attachments.map(({ fileName, fileType, fileSize, fileUrl }) => ({
    fileName,
    fileType,
    fileSize,
    fileUrl,
  }));
